import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_VDOSETTOPIC,
  GET_VDOSETTOPICS,
  GET_VDOSETTOPICS_BY_FILTER,
  ADD_VDOSETTOPIC,
  UPDATE_VDOSETTOPIC,
  DELETE_VDOSETTOPIC,
  DELETE_ONLY_VIDEO, UPDATE_ONLY_VDOSETTOPIC
} from '@/queries/modules/vdoSet/vdoSetTopic.js';

export async function getVdoSetTopics(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETTOPICS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSetTopics', data.getVdoSetTopics);
      context.commit('setSuccess', null);
      return data.getVdoSetTopics
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoSetTopicsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETTOPICS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSetTopics', data.getVdoSetTopicsByFilter);
      context.commit('setSuccess', null);

      return data.getVdoSetTopicsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setVdoSetTopic', data.getVdoSetTopic);
      context.commit('setSuccess', null);
      return data.getVdoSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_VDOSETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const vdoSetTopics = [...context.state.vdoSetTopics];
      vdoSetTopics.push(data.addVdoSetTopic);
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', newItemSuccess(data.addVdoSetTopic.nameLocal));

      return data.addVdoSetTopic;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_VDOSETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.vdoSetTopics.findIndex(item => item.id === data.updateVdoSetTopic.id);
      const vdoSetTopics = [
        ...context.state.vdoSetTopics.slice(0, index),
        data.updateVdoSetTopic,
        ...context.state.vdoSetTopics.slice(index + 1)
      ];
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', updateItemSuccess(data.updateVdoSetTopic.nameLocal));

      return data.updateVdoSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateOnlyVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_ONLY_VDOSETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;
    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // const index = context.state.vdoSetTopics.findIndex(item => item.id === data.updateVdoSetTopic.id);
      // const vdoSetTopics = [
      //   ...context.state.vdoSetTopics.slice(0, index),
      //   data.updateVdoSetTopic,
      //   ...context.state.vdoSetTopics.slice(index + 1)
      // ];
      // context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', updateItemSuccess(data.updateOnlyVdoSetTopic.nameLocal));

      return data.updateOnlyVdoSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteVdoSetTopic(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_VDOSETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else if(data && data.deleteVdoSetTopic){
      const index = context.state.vdoSetTopics.findIndex(item => item.id === data.deleteVdoSetTopic.id);
      const vdoSetTopics = [
        ...context.state.vdoSetTopics.slice(0, index),
        ...context.state.vdoSetTopics.slice(index + 1)
      ];
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', deleteItemSuccess(data.deleteVdoSetTopic.nameLocal));

      return data.deleteVdoSetTopic
    }else{
      context.commit('setProcessing', false);
      return null
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteOnlyVideo(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_ONLY_VIDEO,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else if(data && data.deleteOnlyVideo){
      const index = context.state.vdoSetTopics.findIndex(item => item.id === data.deleteOnlyVideo.id);
      const vdoSetTopics = [
        ...context.state.vdoSetTopics.slice(0, index),
        data.updateVdoSetTopic,
        ...context.state.vdoSetTopics.slice(index + 1)
      ];
      context.commit('setVdoSetTopics', vdoSetTopics);
      context.commit('setSuccess', deleteItemSuccess(data.deleteOnlyVideo.nameLocal));

      return data.deleteOnlyVideo
    }else{
      context.commit('setProcessing', false);
      return null
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

